module.exports = __webpack_public_path__ + "static/media/transf5.6690f4f8.jpg";